import './App.css';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom'; // Import Navigate for redirecting
import About from './components/about';
import Nav from './components/nav';
import Projects from './components/Projects';
import Services from './components/services';
import AddNew from './admin/addnew'; 
import Home from './pages/home';
import BlogPosts from './components/BlogPost';
import ViewPost from './components/ViewPost';
import { useState } from 'react';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";


function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  return (
    <Router>
      <Nav />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/blog" element={<BlogPosts />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/admin/AddNew" element={isAuthenticated ? <AddNew /> : <Navigate to="/admin/AddNew" />} />
        <Route path="/addnew" element={<AddNew />} />

        <Route path="/post/:id" element={<ViewPost />} />
      </Routes>
    </Router>
  );
}

export default App;
